import { Link } from "wouter";
import { Logo } from "@/components/Logo";
import { BookOpen, Code2, ArrowRight } from "lucide-react";

const DOCS = [
  {
    type: "user-documentation",
    label: "User Guide",
    description: "Learn how to use DailyHisaab — billing, inventory, GST invoicing, and more.",
    icon: BookOpen,
    gradient: "from-[#8B2121] to-[#631212]",
    bg: "bg-red-50 dark:bg-red-950/20",
    border: "border-red-100 dark:border-red-900/30",
  },
  {
    type: "developer-documentation",
    label: "Developer Docs",
    description: "API reference, integration guides, and technical documentation.",
    icon: Code2,
    gradient: "from-slate-600 to-slate-800",
    bg: "bg-slate-50 dark:bg-slate-800/40",
    border: "border-slate-200 dark:border-slate-700",
  },
];

export default function Documentation() {
  return (
    <div className="min-h-screen bg-[#FFFBF2] dark:bg-[#1A1614]">
      <header className="sticky top-0 z-30 bg-[#FFFBF2]/90 dark:bg-[#1A1614]/90 backdrop-blur-md border-b border-[#8B2121]/10 dark:border-white/10 px-4 py-3">
        <div className="max-w-2xl mx-auto flex items-center justify-between">
          <Logo size="md" />
          <Link href="/documentation/admin" className="text-xs text-slate-400 dark:text-slate-500 hover:text-[#8B2121] transition-colors">
            Admin
          </Link>
        </div>
      </header>

      <div className="max-w-2xl mx-auto px-4 py-10">
        <div className="text-center mb-10">
          <h1 className="text-3xl font-bold text-slate-900 dark:text-white mb-2">Documentation</h1>
          <p className="text-slate-500 dark:text-slate-400 text-base">Everything you need to know about DailyHisaab</p>
        </div>

        <div className="space-y-4">
          {DOCS.map(({ type, label, description, icon: Icon, gradient, bg, border }) => (
            <Link
              key={type}
              href={`/documentation/${type}`}
              data-testid={`card-doc-${type}`}
              className={`block rounded-3xl p-6 border ${bg} ${border} active:scale-[0.99] transition-transform`}
            >
              <div className="flex items-start gap-4">
                <div className={`flex-shrink-0 w-12 h-12 rounded-2xl bg-gradient-to-br ${gradient} flex items-center justify-center`}>
                  <Icon className="h-6 w-6 text-white" />
                </div>
                <div className="flex-1 min-w-0">
                  <h2 className="font-bold text-lg text-slate-900 dark:text-white mb-1">{label}</h2>
                  <p className="text-sm text-slate-500 dark:text-slate-400 leading-relaxed">{description}</p>
                </div>
                <ArrowRight className="h-5 w-5 text-slate-400 flex-shrink-0 mt-1" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
